import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { LOCATION_BINDER } from "../constant/location-binder.constant";

@Injectable({
  providedIn: "root",
})
export class LocationBinderService {
  requestOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    }),
  };

  constructor(private http: HttpClient) {}
  public getAssemblyData() {
    return this.http.get(`${LOCATION_BINDER.ASSEMBLIES_LIST}`);
  }

  public getGaonData(assemblyId: any) {
    return this.http.get(`${LOCATION_BINDER.GAON_LIST}/${assemblyId}`);
  }
  public getGaonDataWithAssembly(assemblyId: any) {
    return this.http.get(
      `${LOCATION_BINDER.GAON_LIST_WITH_ASSEMBLY}/${assemblyId}`
    );
  }

  public getGatNumberData(gatId: any) {
    return this.http.get(`${LOCATION_BINDER.GATNO_LIST}/${gatId}`);
  }

  public getGanNumberData(ganId: any) {
    return this.http.get(`${LOCATION_BINDER.GAN_NUMBER_LIST}/${ganId}`);
  }
  // public getGanNumberData(ganId: any) {
  //   return this.http.get(`${LOCATION_BINDER.GAON_LIST}/${ganId}`);
  // }

  public getPrabhagData(prabhagId: any) {
    return this.http.get(`${LOCATION_BINDER.PRABHAG_LIST}/${prabhagId}`);
  }

  public getPrabhagAreaData(prabhagAreaId: any) {
    return this.http.get(
      `${LOCATION_BINDER.PRABHAG_AREA_LIST}/${prabhagAreaId}`
    );
  }
}
